// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 引入状态管理
import store from './vuex/store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vue2Editor from "vue2-editor";

Vue.use(Vue2Editor);
//echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts


import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.config.productionTip = false

Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/utils'

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})


// 路由拦截器
router.beforeEach((to, from, next) => {
    if (to.matched.length != 0) {
        if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
            if (Boolean(localStorage.getItem("isLogin"))) { // 通过vuex state获取当前的user是否存在
                next();
            } else {
                next({
                    path: './login',
                    query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
            }
        } else {
            if (Boolean(localStorage.getItem("isLogin"))) { // 判断是否登录
                if (to.path != "./" && to.path != "./login") { //判断是否要跳到登录界面
                    next();
                } else {
                    console.log(1, JSON.parse(localStorage.getItem("allmenu"))[0].url)
                    /**
                     * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页 
                     */
                    next({
                        path: './' + JSON.parse(localStorage.getItem("allmenu"))[0].url
                    })
                }
            } else {
                next();
            }
        }
    } else {
        next({
            path: './login',
            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js